import styled from 'styled-components';

export const Container = styled.div`
  .logo {
    padding-left: 20px;
    margin-top: 20px;
  }
  .side-nav.wide .collapsible-body a {
    padding-left: 23px;
    background-color: transparent;
  }
  .preloader-wrapper {
    margin-left: calc(50% - 50px);
  }
  .btn-container {
    display: flex;
    align-items: center;
  }
  .md-form {
    margin: 0;
  }
  .table-responsive {
    overflow-y: visible;
    overflow-x: visible;
    .select-dropdown {
      margin: 0;
      text-align: center;
    }
    td {
      text-align: center;
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
  .filtrable {
    text-align: center;
  }

`;